"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactColor = require("react-color");

var _react2 = require("@emotion/react");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _ColorPicker = require("./ColorPicker.styles");

var _theme = require("../../util/theme");

var ColorPicker = /*#__PURE__*/_react["default"].forwardRef(function ColorPicker(_ref, forwardedRef) {
  var onColorChange = _ref.onColorChange,
      className = _ref.className,
      defaultColor = _ref.defaultColor,
      pickerBtnStyles = _ref.pickerBtnStyles,
      colorType = _ref.colorType;
  var theme = (0, _react2.useTheme)();
  var presetColors = (0, _react.useMemo)(function () {
    return [theme.color.primary.brand, theme.color.secondary.brand, theme.color.primary.positive, theme.color.secondary.positive, theme.color.primary.negative, theme.color.secondary.negative, theme.color.primary.warning, theme.color.primary.negativeAlt];
  }, [theme.color]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      displayColorPicker = _useState2[0],
      setDisplayColorPicker = _useState2[1];

  var _useState3 = (0, _react.useState)((0, _theme.themeValLookup)(defaultColor)({
    theme: theme
  }) || defaultColor || presetColors[0]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      color = _useState4[0],
      _setColor = _useState4[1]; // Handle color change


  var handleColorChange = (0, _react.useCallback)(function (selectedColor) {
    var complete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var newColor = selectedColor[colorType];

    if ((0, _typeof2["default"])(newColor) === 'object') {
      newColor = "".concat(Object.keys(newColor).join(''), "(").concat(Object.values(newColor).join(', '), ")");
    }

    _setColor(newColor);

    if (complete) {
      onColorChange(newColor);
    }
  }, [_setColor, colorType, onColorChange]);
  var handleColorChangeComplete = (0, _react.useCallback)(function (selectedColor) {
    handleColorChange(selectedColor, true);
  }, [handleColorChange]);
  var handleVisibleChange = (0, _react.useCallback)(function (visible) {
    setDisplayColorPicker(visible);
  }, []);
  (0, _react.useImperativeHandle)(forwardedRef, function () {
    return {
      setColor: function setColor(c) {
        _setColor(c);
      }
    };
  });
  var overlay = (0, _react.useMemo)(function () {
    return (0, _jsxRuntime.jsx)("div", {
      css: _ColorPicker.styles.popover,
      children: (0, _jsxRuntime.jsx)(_reactColor.SketchPicker, {
        color: color,
        presetColors: presetColors,
        onChange: handleColorChange,
        onChangeComplete: handleColorChangeComplete,
        disableAlpha: colorType === 'hex'
      })
    });
  }, [color, handleColorChange, handleColorChangeComplete, presetColors, colorType]);
  return (0, _jsxRuntime.jsx)(_Dropdown["default"], {
    overlay: overlay,
    className: className,
    autoHeight: true,
    hasMinWidth: true,
    visible: displayColorPicker,
    onVisibleChange: handleVisibleChange // Fixed position: the default absolute position will cause the colorpicker to be cut off if the space is not enough
    ,
    strategy: "fixed",
    children: (0, _jsxRuntime.jsxs)(_Button["default"], {
      type: "tertiary",
      css: [_ColorPicker.styles.button, pickerBtnStyles, process.env.NODE_ENV === "production" ? "" : ";label:ColorPicker;"],
      children: [(0, _jsxRuntime.jsx)("span", {
        css: _ColorPicker.styles.value,
        children: color
      }), (0, _jsxRuntime.jsx)("span", {
        css: _ColorPicker.styles.indicator,
        children: (0, _jsxRuntime.jsx)("span", {
          style: {
            background: color
          }
        })
      })]
    })
  });
});

ColorPicker.propTypes = {
  /**
   *  a function to be called once a color change is complete, color value as an argument
   */
  onColorChange: _propTypes.func,
  className: _propTypes.string,

  /**
   * Default color value: can be color or color string from theme (color.brand.positive)
   */
  defaultColor: _propTypes.string,
  pickerBtnStyles: (0, _propTypes.shape)({
    name: _propTypes.string,
    styles: _propTypes.string
  }),
  colorType: (0, _propTypes.oneOf)(['rgb', 'hsl', 'hex'])
};
ColorPicker.defaultProps = {
  onColorChange: function onColorChange() {},
  className: undefined,
  defaultColor: undefined,
  pickerBtnStyles: undefined,
  colorType: 'hex'
};
var _default = ColorPicker;
exports["default"] = _default;
//# sourceMappingURL=ColorPicker.js.map